<template>
    <div id="productDetail" :style="{background:'url('+newsBg2+')'}">
        <div class="infoBox contentBox">
            <div class="infoLeft">
                <div class="top">
                    <div class="mainImg">
                        <img ref="mainImg" :src="baseUrl+productDetailData.cover_img">
                    </div>
                    <div class="imgList">
                        <div class="imgs" v-for="item in productPhotos" :ref="item" :key="item" @mouseenter="changeMainImg(item)" @mouseleave="changeMainImg(item,true)">
                            <img :src="baseUrl+item"/>
                        </div>                        
                    </div>
                </div>
                <div class="bottom">
                    <div class="list">
                        <div class="title" style="text-align: center; padding-top: 20px;">
                            <h3 style="margin: 0; font-size: 18px; color: #333;">相关产品</h3>
                        </div>
                        <div class="scroll-list">
                            <div class="item" v-for="item in similarProductList" :key="item.id" @click="linkTo(item.id)">
                                <div class="img">
                                    <img :src="baseUrl+item.cover_img_text"/>
                                </div>
                                <div class="text">
                                    {{item.name}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="infoRight">
                <div class="top">
                    <div class="title">
                        <h2>{{ productDetailData.name }}</h2>
                    </div>
                    <div class="top imgBox">
                        <div class="mainImg">
                            <img ref="mainImgM" :src="baseUrl+productDetailData.cover_img">
                        </div>
                        <div class="imgList">
                            <div class="imgs" v-for="item in productPhotos" :ref="item" :key="item" @mouseenter="changeMainImg(item)" @mouseleave="changeMainImg(item,true)">
                                <img :src="baseUrl+item"/>
                            </div>                        
                        </div>
                    </div>
                    <div class="text">
                        {{ productDetailData.describe }}
                    </div>
                </div>
                <div class="bottom" v-html="productDetailData.content"></div>
                <div class="list">
                    <div class="title">
                        <h2>相关产品</h2>
                    </div>
                    <div class="scroll-list">
                        <div class="item" v-for="item in similarProductList" :key="item.id" @click="linkTo(item.id)">
                            <div class="img">
                                <img :src="baseUrl+item.cover_img_text"/>
                            </div>
                            <div class="text">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//静态资源导入
import newsBg2 from '@/assets/img/newsBg2.jpg'

export default {
    data(){
        return {
            baseUrl:window.config.apiUrl,
            productDetailData:[],
            productPhotos:[],
            similarProductList:[],
            newsBg2:newsBg2,
            selectedProduct: '',
        }
    },
    watch:{
        "$route.query.id":function(){
            this.getProductInfo();
            this.$nextTick(function(){
                    this.fixContent();         
            })     
        }
    },
    methods:{
        async getProductInfo(){
            this.productDetailData = await this.$root.getProductDetailData(this.$route.query.id);
            console.log(this.productDetailData);
            this.similarProductList = await this.$root.getSimilarProductList(this.$route.query.id);
            console.log(this.similarProductList);
            this.productPhotos = this.productDetailData.product_photos.split(',');    
            this.$root.loadingClose();         
        },
        fixContent(){
            //轮询10次 修复图片宽度
            let count = 0;
            let listen = setInterval(() => {
                let infoRight = document.getElementsByClassName('infoRight')[0];
                if(!infoRight){
                    clearInterval(listen);
                }
                try{
                    let imgs = infoRight.getElementsByTagName('img');
                    for(let i=0;i<imgs.length;i++){
                        imgs[i].style.width = "100%";
                        imgs[i].style.height = "auto";
                    }
                    count++;
                    if(count > 10){
                        clearInterval(listen);
                    }
                }
                catch{
                    console.log("warnning :not fond imgs")
                }                
            }, 500);            
        },
        linkTo(id){
            window.open("/#/productDetail?id="+id,"_blank");
        },
        handleSelectChange(id){
            this.linkTo(id);
            this.selectedProduct = '';
        },
        changeMainImg(item,isLeave = false){
            if(isLeave){
                this.$refs[item].forEach(element => {
                    element.style.border = "1px solid transparent";
                });
                //this.$refs[item][0].style.border = "1px solid transparent";
            }
            else{
                this.$refs[item].forEach(element => {
                    element.style.border = "1px solid #5e8743";
                })
                this.$refs.mainImg.src = this.baseUrl+item;
                this.$refs.mainImgM.src = this.baseUrl+item;
                // this.$refs[item][0].style.border = "1px solid #5e8743";
            }            
        }
    },
    created(){
        this.getProductInfo();
    },
    mounted(){   
        this.$nextTick(function(){
            this.fixContent();           
        })           
    },
    destroyed() {
    }
}
</script>

<style lang="scss" src="@/assets/css/productDetail.scss" scoped>

</style>